import { Component, Fragment } from 'react'
import Layout from '../components/share/Layout'

import {
  SettingService, HeaderService, SlideService, TinTucService, GalleryService
} from '../services'
import { tagContent } from "../util/jqueryUtil";

import { CONTENT } from '../const/content';
import ContentComponent from '../components/share/ContentComponent';
import FormDangKy from '../components/index/FormDangKy';
import { PageTransition } from "next-page-transitions";
import { SETTING } from '../const/setting';
import SpinnersBigImage from '../components/share/Spinners/SpinnersBigImage';


export default class extends Component<any, any> {

  constructor(props) {
    super(props)
  }


  static async getInitialProps() {
    const layoutProps = await Layout.getInitialProps();
    // const title = await SettingService.getSetting(SETTING.title_trang_chu);
    const header = await HeaderService.getsHeader([
      CONTENT.CONTENT_ROYAL_TUYENSINH_BIEUPHI_VN,
      CONTENT.CONTENT_ROYAL_HOME_MAP_VN,
      ,

    ],
      []
    )
    const CONTENT_ROYAL_CHUONGTRINHHOC_MAMNON_VN
      = header.contentValue.find(x => x.key == CONTENT.CONTENT_ROYAL_TUYENSINH_BIEUPHI_VN
      );
    const CONTENT_ROYAL_HOME_MAP_VN
      = header.contentValue.find(x => x.key == CONTENT.CONTENT_ROYAL_HOME_MAP_VN
      );
    const title = await SettingService.getSetting(SETTING.royal_title_tuyen_sinh_bieu_phi_english);    
    return {
      title: title.value.value,
      layoutProps,
      CONTENT_ROYAL_CHUONGTRINHHOC_MAMNON_VN: CONTENT_ROYAL_CHUONGTRINHHOC_MAMNON_VN.content,
      CONTENT_ROYAL_HOME_MAP_VN: CONTENT_ROYAL_HOME_MAP_VN.content,
    }
   
  }

  componentDidMount() {
    const fragment = window.location.hash.substr(1);
    const elementScrollTo = document.getElementById(fragment);
    if (elementScrollTo) {
      elementScrollTo.scrollIntoView();
    }
    tagContent();
  }

  render() {
    return (
      <Layout title={this.props.title} {...this.props.layoutProps}>
        {/* <PageTransition timeout={400} classNames="page-transition"> */}
          <Fragment >
            <ContentComponent content={this.props.CONTENT_ROYAL_CHUONGTRINHHOC_MAMNON_VN} />
              <FormDangKy />
            <ContentComponent content={this.props.CONTENT_ROYAL_HOME_MAP_VN} />
          </Fragment>
        {/* </PageTransition> */}
        <style jsx global>
          {`
                .page-transition-enter {
                  opacity: 0;
                }
                .page-transition-enter-active {
                  opacity: 1;
                  transition: opacity ${400}ms;
                }
                .page-transition-exit {
                  opacity: 1;
                }
                .page-transition-exit-active {
                  opacity: 0;
                  transition: opacity ${400}ms;
                }
              `}
        </style>

      </Layout>
    )
  }
}
